import { generateClient } from 'aws-amplify/api';
import { getUser } from "../graphql/queries";

const client = generateClient();

export default async (id) => {
    try {
        const { data } = await client.graphql({
            query: getUser,
            variables: {
                id,
            },
        });
        return data.getUser;
    } catch (ex) {
        console.log("Failed to fetch user", ex);
    }
};
